import { parseISO, differenceInMinutes } from 'date-fns';
import { ShipmentStopsGridData } from '@pages/reporting-pages/shipment-stops/types/ShipmentStopsGridData';
import { isMinDate } from 'components/global/utils';
import { TimelineLimitTimes } from '@pages/reporting-pages/shipment-stops/types/TimelineLimitTimes';
import { TimelineData } from '@pages/reporting-pages/shipment-stops/types/TimelineData';



const useTimelineData = (item: ShipmentStopsGridData, limitTimes: TimelineLimitTimes) => {
	const { plannedArrival, plannedDeparture, realArrival, realDeparture } = item;
	const { hoursLength, minArrival } = limitTimes;

	let minutesInDay = hoursLength * 60 / 100;
	let minArrivalDate = minArrival ? parseISO(minArrival) : parseISO(plannedArrival);

	
	// planned block
	let showPlannedBlock = !isMinDate(plannedArrival) && !isMinDate(plannedDeparture);

	let plannedArrivalDate = parseISO(plannedArrival);
	let plannedDepartureDate = parseISO(plannedDeparture);

	let plannedBlockMargin = differenceInMinutes(plannedArrivalDate, minArrivalDate);
	let plannedBlockLength = differenceInMinutes(plannedDepartureDate, plannedArrivalDate);
	
	
	// real block
	let showRealBlock = !isMinDate(realArrival) && !isMinDate(realDeparture);

	let realArrivalDate = parseISO(realArrival);
	let realDepartureDate = parseISO(realDeparture);

	let realBlockMargin = differenceInMinutes(realArrivalDate, minArrivalDate);
	let realBlockLength = differenceInMinutes(realDepartureDate, realArrivalDate);
	
	
	// block color
	let difference = realBlockMargin > plannedBlockMargin ? realBlockMargin - plannedBlockMargin : plannedBlockMargin - realBlockMargin;
	let colorStatus = !showRealBlock ? 'status-none' : difference <= 60 ? 'status-success' : difference <= 90 ? 'status-warning' : difference > 90 ? 'status-danger' : 'status-none';

	const timelineData: TimelineData = {
		minutesInDay,
		plannedBlockMargin,
		plannedBlockLength,
		realBlockMargin,
		realBlockLength,
		difference,
		showPlannedBlock,
		showRealBlock,
		colorStatus,
	}
	
	return timelineData;
}

export default useTimelineData;